import { styled } from 'styled-components';

const PageStyled = styled.div`
height:100%;
`;

export default PageStyled;
